import { registerAgentEvents } from "./agent";
import { registerApiCallEvents } from "./call";
import { registerApiChatEvents } from "./chat";
import registerCallbackHandlers from "./callback";
import registerTaskEvents from "./task";

export default function registerApiHandlers() {
    registerApiCallEvents();
    registerTaskEvents();
    registerAgentEvents();
    registerApiChatEvents();
    registerCallbackHandlers();
}